import React from 'react';
import { CarouselPumoModuleFragment } from '../../generated/types';
import { SingleLooksModule } from './SingleLooksModule';

interface Props {
  carousels: CarouselPumoModuleFragment[];
}

export const LooksModule: React.FC<Props> = ({ carousels }) => (
  <>
    {carousels.map(carouselPumoModule => (
      <SingleLooksModule key={carouselPumoModule.id} carousel={carouselPumoModule} />
    ))}
  </>
);
